<template>
  <div>
		<Layout :isSuccess="true">
      <template v-slot:containerZone>
        <div class="my-4">
          <v-row class="bg-white mx-0">
            <v-col cols="12" class="text-center pt-4">
              <h1>{{ $t('meter.electricity_back_log') }}</h1>
            </v-col>
          </v-row>
        </div>
        <template>
          <v-card elevation="0">
            <v-card-text>
              <v-row>
                <v-col cols="6">
                  <span>{{ $t('meter.select_date') }}</span>
                  <v-menu
                    ref="menuDate"
                    v-model="menuDate"
                    :return-value.sync="formData.date"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="$helper.datelabel(formData.date)"
                        :placeholder="$t('date')"
                        solo
                        hide-details
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        height="56"
                        :disabled="isLoading"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="formData.date"
                      no-title
                      locale="th"
                      :header-date-format="$helper.headerDateFormat"
                      :year-format="$helper.yearFormat"
                      persistent-hint
                      :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text @click="menuDate = false">
                        {{ $t('cancel') }}
                      </v-btn>
                      <v-btn
                        text
                        color="success"
                        @click="$refs.menuDate.save(formData.date)"
                      >
                        {{ $t('confirm') }}
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="5">
                  <span>{{ $t('time') }}</span>
                  <v-row>
                    <v-col cols="5">
                      <v-select
                        v-model="filterData.startTime"
                        :items="timeOptions"
                        item-value="value"
                        item-text="text"
                        solo
                        hide-details
                        height="56"
                        :suffix="$t('timeunit.minute.short')"
                        :disabled="isLoading"
                        :no-data-text="$t('noinfo')"
                      />
                    </v-col>
                    <v-col cols="2">
                      <div class="text-center pt-4">{{ $t('to') }}</div>
                    </v-col>
                    <v-col cols="5">
                      <v-select
                        v-model="filterData.endTime"
                        :items="timeOptions"
                        item-value="value"
                        item-text="text"
                        solo
                        hide-details
                        height="56"
                        :suffix="$t('timeunit.minute.short')"
                        :disabled="isLoading"
                        :no-data-text="$t('noinfo')"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="1">
                  <span class="white--text">-</span>
                  <v-btn 
                    color="success" 
                    height="56" 
                    block 
                    @click="initData()"
                    :disabled="isLoading"
                  >
                    {{ $t('search') }}
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <span>{{ $t('market.market') }}</span>
                  <v-autocomplete
                    v-model="selectMarket"
                    :items="marketMeter"
                    item-text="name"
                    :item-value="d => d"
                    full-width 
                    solo
                    hide-details
                    clearable
                    :disabled="isLoading"
                  />
                </v-col>
                <v-col cols="6">
                  <span>{{ $t('area.space') }}</span>
                  <v-autocomplete
                    v-model="selectArea"
                    :items="areaOptions"
                    item-text="name"
                    :item-value="d => d"
                    full-width 
                    solo
                    hide-details
                    clearable
                    :disabled="isLoading"
                  />
                </v-col>
                <v-col cols="6">
                  <span>{{ $t('meter.title') }}</span>
                  <v-autocomplete
                    v-model="selectMeter"
                    :items="merterOptions"
                    :item-text="meterName"
                    :item-value="d => d"
                    full-width 
                    solo
                    hide-details
                    clearable
                    :disabled="isLoading"
                  />
                </v-col>

              </v-row>

            </v-card-text>
          </v-card>
          <div class="flex justify-end py-3">
            <v-btn 
              class="blue white--text"
              @click="exportExcel()"
              :disabled="isLoading"
            >
              <v-icon left>mdi-file-excel</v-icon> Export Excel
            </v-btn>
          </div>
          <v-data-table
            :headers="dataTable.headers"
            :items="datasets"
            class="my-3 border-2 cursor-pointer"
            :items-per-page="20"
            :loading="isLoading"
            :no-data-text="$t('noinfo')"
            :no-results-text="$t('no_matching_records_found')"
          >
            <template v-slot:item.meterName="{ item }">
              {{ item.meter.isMain ? this.$t('main') : item.meter.name }}
            </template>
            <template v-slot:item.time="{ item }">
              {{ $moment(item.dateTime).format("H.mm") }}
            </template>
          </v-data-table>
        </template>

        <!-- <v-card class="d-flex justify-center py-10" v-if="isLoading">
          <v-progress-circular
            indeterminate
            size="64"
            color="green"
          ></v-progress-circular>
        </v-card> -->
			</template>
		</Layout>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
	</div>
</template>
<script>
import { mapState } from "vuex";
import Layout from "@/components/Layout.vue";
import SelectMonthYear from "@/components/SelectMonthYear.component.vue";
import { DigitalMeterReport } from "../../classes"
import { ExportDigitalMeterLog } from "@/exports";

export default {
	components: {
		Layout,
    SelectMonthYear,
	},
  data() {
    return {
			projectId: this.$route.params.projectId,
			isLoading: false,
			isError: false,
      selectedMonthYear: null,
      markets: null,
      project: null,
      formData: {
        date: this.$moment().format("YYYY-MM-DD"),
      },
      menuDate: false,
      dataTable: {
        headers: [
          { 
            text: this.$t('market.market'),
            value: "meter.market.name",
            align: "center" 
          },
          { 
            text: this.$t('time') + " (" + this.$t('timeunit.minute.short') + ")",
            value: "time",
            align: "center" 
          },
          { 
            text: this.$t('area.space'),
            value: "meter.area.name",
            align: "center" 
          },
          { 
            text: this.$t('meter.meter_name'),
            value: "meterName",
            align: "center" 
          },
          { 
            text: this.$t('meter.unit_title'),
            value: "unit",
            align: "right" 
          },
        ],
        data: []
      },
      marketMeter: [],
      areaMeter: [],
      selectMarket: null,
      selectArea: null,
      selectMeter: null,
      timeOptions: [
        { text: "0.00", value: 0 },
        { text: "1.00", value: 1 },
        { text: "2.00", value: 2 },
        { text: "3.00", value: 3 },
        { text: "4.00", value: 4 },
        { text: "5.00", value: 5 },
        { text: "6.00", value: 6 },
        { text: "7.00", value: 7 },
        { text: "8.00", value: 8 },
        { text: "9.00", value: 9 },
        { text: "10.00", value: 10 },
        { text: "11.00", value: 11 },
        { text: "12.00", value: 12 },
        { text: "13.00", value: 13 },
        { text: "14.00", value: 14 },
        { text: "15.00", value: 15 },
        { text: "16.00", value: 16 },
        { text: "17.00", value: 17 },
        { text: "18.00", value: 18 },
        { text: "19.00", value: 19 },
        { text: "20.00", value: 20 },
        { text: "21.00", value: 21 },
        { text: "22.00", value: 22 },
        { text: "23.00", value: 23 },
        { text: "23.59", value: 24 },
      ],
      filterData: {
        startTime: 0,
        endTime: 24
      },
      hashMeter: {},
      records: []
    }
  },
  computed: {
    ...mapState({
      sessionAdmins: (state) => state.admin.sessionAdmins,
      meters: (state) => state.meter.meters,
    }),
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    },
    areaOptions() {
      if(this.selectMarket){
        return this.areaMeter.filter(d => d.market.objectId == this.selectMarket.objectId)
      }else{
        return this.areaMeter
      }
    },
    merterOptions(){
      if(this.selectArea){
        return this.meters.filter(d => d.market.objectId == this.selectArea.market.objectId)
      }else{
        if(this.selectMarket){
          return this.meters.filter(d => d.market.objectId == this.selectMarket.objectId)
        }else{
          return this.meters
        }
      }
    },
    datasets(){
      let data = this.records
      if(this.selectMeter){
        data = data.filter(d => d.meter.objectId == this.selectMeter.objectId)
      }
      if(this.selectArea){
        data = data.filter(d => d.meter.market.objectId == this.selectArea.market.objectId)
      }
      if(this.selectMarket){
        data = data.filter(d => d.meter.market.objectId == this.selectMarket.objectId)
      }

      data = data.filter(d => this.$moment(d.dateTime).hour() >= this.filterData.startTime)
      data = data.filter(d => this.$moment(d.dateTime).hour() < this.filterData.endTime)

      return data
    }
  },
  async created(){
    this.isLoading = true
    try{
      
      if(this.admins){
        this.project = this.admins[0].project
        this.markets = this.admins.map(d => d.market)
      }
      await this.$store.dispatch("meter/getMeterDigitalByMarkets", this.markets.map(d => d.objectId))
      let hashMarket = {}
      let hashArea = {}
      for(let meter of this.meters){
        if(meter.digitalMeterData){
          this.hashMeter[`${meter.digitalMeterData.cust_id}_${meter.digitalMeterData.meter_id}`] = meter
        }

        if(!hashMarket[meter.market.objectId]) hashMarket[meter.market.objectId] = meter.market
        if(!hashArea[meter.area.objectId]) hashArea[meter.area.objectId] = meter.area
      }

      this.marketMeter = []
      this.areaMeter = []
      for(let key in hashMarket){
        this.marketMeter.push(hashMarket[key])
      }

      for(let key in hashArea){
        this.areaMeter.push(hashArea[key])
      }

      this.isLoading = false
    }catch(error){
      this.isError = true
      this.isLoading = false
    }
  },
	methods: {
		async initData(){
			this.isLoading = true
			try {
        let result = await DigitalMeterReport.getDateReport(this.project.digitalMeterData.cust_id_list, this.formData.date)
        
        for(let reports of result){
          for(let report of reports){
            for(let i = 1; i <= 256; i++){
              if(report && report["tb_kWh" + i]){
                let meter = this.hashMeter[`${report.cust_id}_${i}`]
                if(meter){
                  this.records.push({
                    cust_id: report.cust_id,
                    dateTime: report.tb_datetime,
                    unit: parseFloat(report["tb_kWh" + i]).toFixed(2),
                    meter: meter
                  })
                }
              }
            }
          }
        }
				this.isLoading = false
			} catch(error) {
				this.isLoading = false
				this.isError = true
			}
		},
    meterName(meter){
      return `[${meter.area.name}] ${meter.isMain ? this.$t('main') : meter.name}`
    },
    exportExcel(){
      try{
        ExportDigitalMeterLog.exportDigitalMeterLog(this.datasets, this.formData.date)
      }catch(error){
        this.isError = true
      }
    }
	}
}
</script>
<style scoped>
.router-link-exact-active {
  @apply text-screamin-green-700 !important;
}
.router-class {
  @apply bg-white block w-full p-3 text-center text-black transition-all  rounded hover:text-screamin-green-700 hover:scale-110;
}
</style>